<template>
    <div class="add_context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">
                <span>{{ viewTitle }}</span>
                <span v-if="staff_type === 'user'"
                      style="color: #F56C6C;font-size: 15px;padding: 0 5px">
                    (编辑该人员信息，岗位，更换成其他人员请使用更换人员功能)
                </span>
            </div>
        </div>

        <div class="main_box" v-if="staff_type === 'user'">
            <div class="left_box">
                <el-form :model="form" ref="form" label-width="120px" :rules="rules_edit">
                    <el-form-item label="姓名:" prop="name">
                        <el-input v-model="form.name" class="width_220" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号:" prop="phone">
                        <el-input v-model="form.phone"
                                  class="width_220"
                                  placeholder="请输入手机号"></el-input>
                        <span style="padding-left: 10px">
                            <el-checkbox v-model="phone_checked"></el-checkbox>
                        </span>
                    </el-form-item>
                    <el-form-item label="工号:" prop="job_number">
                        <el-input v-model="form.job_number" class="width_220" placeholder="请输入工号"></el-input>
                    </el-form-item>

                    <el-form-item label="岗位:">
                        <div>{{ form.job }}</div>
                    </el-form-item>
                    <el-form-item label="职位:">
                        <el-radio-group v-model="form.is_manager" :disabled="true">
                            <el-radio v-for="(item, index) in ifList" :key="index" :label="item.value">
                                {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="submit_loading" @click="submit_user">
                            保存
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="main_box" v-if="staff_type === 'work'">
            <div class="left_box">
                <el-form :model="form" ref="form" label-width="120px" :rules="rules_edit">
                    <el-form-item label="姓名:">
                        <div>
                            <span>{{ form.name }}</span>
                            <span v-if="form.is_quit == 2">（离职）</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="手机号:">
                        <div>{{ form.phone }}</div>
                    </el-form-item>
                    <el-form-item label="工号:">
                        <div>{{ form.job_number }}</div>
                    </el-form-item>

                    <el-form-item label="岗位:" prop="job">
                        <el-input v-model="form.job"
                                  class="width_220"
                                  placeholder="请输入岗位"></el-input>
                    </el-form-item>
                    <el-form-item label="职位:">
                        <el-radio-group v-model="form.is_manager">
                            <el-radio v-for="(item, index) in ifList"
                                      :key="index"
                                      :label="item.value">
                                {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary"
                                   :loading="submit_loading"
                                   @click="submit_work">
                            保存
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right_box">
                <el-row style="height: 100%">
                    <el-col :span="12" style="height: 100%">
                        <div class="select_table table_box">
                            <div class="table_header">
                                管理医院
                            </div>
                            <div class="table">
                                <el-table :data="selectHos" height="100%">
                                    <el-table-column type="index"
                                                     width="60"
                                                     label="序号"></el-table-column>
                                    <el-table-column label="医院名称"
                                                     show-overflow-tooltip
                                                     prop="name"></el-table-column>
                                    <el-table-column label="产品"
                                                     show-overflow-tooltip
                                                     :formatter="showDrug"
                                                     prop="drug_code"></el-table-column>
                                    <el-table-column label="操作"
                                                     width="60"
                                                     align="center">
                                        <template slot-scope="scope">
                                            <span class="table_del_btn"
                                                  @click="delRow(scope)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12" style="height: 100%">
                        <div class="all_table table_box">
                            <div class="table_search">
                                <div>
                                    <span class="table_search_title">选择产品线：</span>
                                    <span>
                                        <el-select v-model="now_select_drug_code"
                                                   size="small"
                                                   class="width_220">
                                            <el-option v-for="(item, index) in drug_code_list"
                                                       :value="item.drug_code"
                                                       :label="item.name"
                                                       :key="index"></el-option>
                                        </el-select>
                                    </span>
                                </div>
                                <div>
                                    <el-row :gutter="10">
                                        <el-col :span="12">
                                            <el-input size="small"
                                                      v-model="hos_search_input"
                                                      placeholder="请输入医院名称"
                                                      @change="getAllHospital"
                                                      clearable></el-input>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-cascader size="small"
                                                         placeholder="请选择省市"
                                                         clearable
                                                         v-model="hos_search_cascader"
                                                         :options="city_list"
                                                         :props="cascader_props"
                                                         @change="getAllHospital"></el-cascader>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                            <div class="table">
                                <el-table :data="allHos"
                                          @row-dblclick="select_row"
                                          empty-text="请输入搜索条件筛选数据"
                                          height="100%">
                                    <el-table-column type="index"
                                                     width="60"
                                                     label="序号"></el-table-column>
                                    <el-table-column label="医院名称"
                                                     show-overflow-tooltip
                                                     prop="name"></el-table-column>
                                    <el-table-column label="操作" width="90">
                                        <template slot-scope="scope">
                                            <el-button @click="select_row(scope.row)" size="mini">
                                                添加
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </div>
        <div class="main_box" v-if="staff_type === 'change'">
            <div class="left_box">
                <el-form :model="form" ref="form" label-width="120px" :rules="rules_edit">
                    <el-form-item label="姓名:" prop="name">
                        <el-input v-model="form.name" class="width_220" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号:" prop="phone">
                        <div class="form_item_box">
                            <el-input v-model="form.phone" class="width_220" @input="phoneInputChange"
                                      placeholder="请输入手机号"></el-input>
                            <span class="warning_msg_span" v-if="warning_msg">{{ warning_msg }}</span>
                        </div>
                    </el-form-item>
                    <el-form-item label="工号:" prop="job_number">
                        <el-input v-model="form.job_number" class="width_220" placeholder="请输入工号"></el-input>
                    </el-form-item>

                    <el-form-item label="岗位:" prop="job">
                        <div>{{ form.job }}</div>
                    </el-form-item>
                    <el-form-item label="职位:">
                        <el-radio-group v-model="form.is_manager" :disabled="true">
                            <el-radio v-for="(item, index) in ifList" :key="index" :label="item.value">
                                {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="submit_loading" @click="submit_change">
                            保存
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <div class="main_box" v-if="staff_type === 'add'">
            <div class="left_box">
                <el-form :model="form" ref="form" label-width="120px" :rules="rules">
                    <el-form-item label="姓名:" :prop="getProp('name')">
                        <el-input v-model="form.name" class="width_220" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号:" prop="phone">
                        <el-input v-model="form.phone" class="width_220" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="工号:" :prop="getProp('job_number')">
                        <el-input v-model="form.job_number" class="width_220" placeholder="请输入工号"></el-input>
                    </el-form-item>

                    <el-form-item label="岗位:" prop="job">
                        <el-input v-model="form.job" class="width_220" placeholder="请输入岗位"></el-input>
                    </el-form-item>
                    <el-form-item label="职位:">
                        <el-radio-group v-model="form.is_manager">
                            <el-radio v-for="(item, index) in ifList" :key="index" :label="item.value">
                                {{ item.name }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" :loading="submit_loading" @click="submit">
                            保存
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right_box">
                <el-row style="height: 100%">
                    <el-col :span="12" style="height: 100%">
                        <div class="select_table table_box">
                            <div class="table_header">
                                管理医院
                            </div>
                            <div class="table">
                                <el-table :data="selectHos" height="100%">
                                    <el-table-column type="index" width="60" label="序号"></el-table-column>
                                    <el-table-column label="医院名称"
                                                     show-overflow-tooltip
                                                     prop="name"></el-table-column>
                                    <el-table-column label="产品"
                                                     show-overflow-tooltip
                                                     :formatter="showDrug"
                                                     prop="drug_code"></el-table-column>
                                    <el-table-column label="操作" width="60" align="center">
                                        <template slot-scope="scope">
                                            <span class="table_del_btn" @click="delRow(scope)">
                                                <i class="el-icon-delete"></i>
                                            </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12" style="height: 100%">
                        <div class="all_table table_box">
                            <div class="table_search">
                                <div>
                                    <span class="table_search_title">选择产品线：</span>
                                    <span>
                                        <el-select v-model="now_select_drug_code"
                                                   size="small"
                                                   class="width_220">
                                            <el-option v-for="(item, index) in drug_code_list"
                                                       :value="item.drug_code"
                                                       :label="item.name"
                                                       :key="index"></el-option>
                                        </el-select>
                                    </span>
                                </div>
                                <div>
                                    <el-row :gutter="10">
                                        <el-col :span="12">
                                            <el-input size="small"
                                                      v-model="hos_search_input"
                                                      placeholder="请输入医院名称"
                                                      @change="getAllHospital"
                                                      clearable></el-input>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-cascader size="small"
                                                         placeholder="请选择省市"
                                                         clearable
                                                         v-model="hos_search_cascader"
                                                         :options="city_list"
                                                         :props="cascader_props"
                                                         @change="getAllHospital"></el-cascader>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                            <div class="table">
                                <el-table :data="allHos" @row-dblclick="select_row" empty-text="请输入搜索条件筛选数据"
                                          height="100%">
                                    <el-table-column type="index" width="60" label="序号"></el-table-column>
                                    <el-table-column label="医院名称" show-overflow-tooltip prop="name"></el-table-column>
                                    <el-table-column label="操作" width="90">
                                        <template slot-scope="scope">
                                            <el-button @click="select_row(scope.row)" size="mini">
                                                添加
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"
    import {clone} from "../../global/utils";

    export default {
        name: "add",
        data() {
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback()
                }
                let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的手机号！'))
                }
            };
            const checkPhoneTwo = (rule, value, callback) => {
                if (!value && !this.phone_checked) {
                    this.warning_msg = '';
                    callback(new Error('请输入手机号！'))
                }
                if(!value && this.phone_checked) {
                    this.warning_msg = '';
                    callback()
                }
                let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (reg.test(value)) {
                    callback()
                } else {
                    this.warning_msg = '';
                    callback(new Error('请输入正确的手机号！'))
                }
            };
            return {
                viewTitle: '添加成员',
                form: {
                    name: '',
                    job_number: '',
                    phone: '',
                    job: '',
                    is_manager: 1,
                    is_fake: 1, // 1否2是
                },
                rules: {
                    name: [{required: true, message: '请输入姓名！', trigger: 'blur'}],
                    job_number: [{required: true, message: '请输入工号！', trigger: 'blur'}],
                    job: [{required: true, message: '请输入岗位！', trigger: 'blur'}],
                    phone: [{required: false, validator: checkPhone, trigger: 'blur'}],
                },
                rules_edit: {
                    name: [{required: true, message: '请输入姓名！', trigger: 'blur'}],
                    job_number: [{required: true, message: '请输入工号！', trigger: 'blur'}],
                    phone: [{required: true, validator: checkPhoneTwo, trigger: 'blur'}],
                    job: [{required: true, message: '请输入岗位！', trigger: 'blur'}],
                },

                phone_checked: false,

                warning_msg: '', // 手机号警告信息

                ifList: [
                    {name: '代表', value: 1},
                    {name: '经理', value: 2},
                    {name: 'RPM', value: 3},
                    {name: 'RPMHead', value: 4},
                ],

                hos_search_input: '',
                hos_search_cascader: [],
                cascader_props: {
                    expandTrigger: 'hover',
                    value: 'name',
                    label: 'name',
                    children: 'city_list',
                },

                selectHos: [],
                allHos: [],

                submit_loading: false,

                old_job: '', // 修改之前的岗位

                now_select_drug_code: 1, // 当前选中的药物
            }
        },
        computed: {
            ...mapState('manageData', [
                'staff_data',
                'staff_type',
                'selectTreeNode',
                'showTree',
            ]),
            ...mapState("comInformationData", [
                'city_list',
                'drug_code_list', // 药物列表
            ])
        },
        watch: {
            phone_checked() {
                this.form.is_fake = this.phone_checked ? 2 : 1;
                this.rules_edit.phone[0].required = !this.phone_checked;
                this.$forceUpdate()
            }
        },
        mounted() {
            if (this.staff_data) {
                this.viewTitle = this.staff_type === 'user' ? '编辑员工' :
                    this.staff_type === 'work' ? '编辑岗位' :
                        this.staff_type === 'change' ? '更换人员' : '';

                this.form = clone(this.staff_data);
                this.phone_checked = this.form.is_fake == 2;
                if (this.staff_type === 'user') {

                } else if (this.staff_type === 'work') {
                    this.getSelectHospital();
                    this.old_job = clone(this.form.job);
                } else if (this.staff_type === 'change') {
                    this.form.name = '';
                    this.form.phone = '';
                    this.form.job_number = '';
                }
            } else {
                this.viewTitle = '添加员工';
                this.form = {
                    name: '',
                    job_number: '',
                    phone: '',
                    job: '',
                    is_manager: false,
                    department_id: this.selectTreeNode.department_id,
                    is_fake: 1, // 1否2是
                };
                this.phone_checked = false;
            }
            this.submit_loading = false;


        },
        methods: {
            getSelectHospital() {
                let params = {
                    job: this.form.job
                };
                this.httpGet('/hospital/job_hospital', params).then(res => {
                    this.selectHos = res.data
                })
            },
            getFormData(item) {
                console.log(item, '117');
                if (item.department_id) {
                    let params = {
                        department_id: item.department_id
                    };
                    this.httpGet('/user/rep_job', params).then(res => {
                        this.form = res.data
                    })
                }
            },
            showDrug(row, column, cellValue, index) {
                let text = '';
                this.drug_code_list.map(v => {
                    if (cellValue == v.drug_code) {
                        text = v.name
                    }
                });
                return text
            },

            phoneInputChange(value) {
                // 验证手机号 只有更换人员才验证
                this.warning_msg = '';
                let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (!value || !reg.test(value)) return;
                let params = {
                    phone: value
                };
                this.httpGet('/user/rep/get_by_phone', params).then(res => {
                    console.log(res, '368');
                    if (res.data && res.data.job_list && res.data.job_list.length > 0) {
                        this.warning_msg = '该手机号已绑定其他岗位!'
                    }
                });
            },


            getProp(val) {
                if (this.form.phone) {
                    return val
                } else {
                    return ''
                }
            },
            goBack() {
                if (this.showTree) {
                    this.$emit('changeTopTab', 'tableView')
                } else {
                    this.$emit('changeTopTab', 'lookView')
                }

            },
            submit() {
                // 新增
                this.submit_loading = true;
                this.$refs.form.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.form,
                            job_hospital_list: this.selectHos
                        };

                        this.httpPost('/user/rep_job', params).then(res => {
                            this.$message.success(this.viewTitle + '成功！');
                            this.submit_loading = false;
                            this.goBack()
                        }).catch(err => {
                            this.$message.warning(err.msg);
                            this.submit_loading = false;
                        })
                    }
                })
            },
            submit_user() {
                // 编辑人员

                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.submit_loading = true;
                        let params = {
                            user_id: this.form.user_id,
                            name: this.form.name,
                            phone: this.form.phone || '',
                            job_number: this.form.job_number,
                            is_fake: this.form.is_fake
                        };
                        let url = `/user/rep_job/update_user?department_id=${this.form.department_id}&job=${this.form.job}`;
                        this.httpPost(url, params).then(res => {
                            this.$message.success(this.viewTitle + '成功！');
                            this.submit_loading = false;
                            this.goBack()
                        }).catch(err => {
                            this.$message.warning(err.msg);
                            this.submit_loading = false;
                        })
                    }
                })
            },
            submit_work() {
                // 编辑岗位
                this.submit_loading = true;
                this.$refs.form.validate(valid => {
                    if (valid) {
                        let params = {
                            is_manager: this.form.is_manager,
                            department_id: this.form.department_id,
                            job: this.form.job,
                            job_hospital_list: this.selectHos
                        };
                        let old_job = encodeURIComponent(this.old_job);
                        let url = `/user/rep_job/update?department_id=${this.form.department_id}&job=${old_job}`;
                        this.httpPost(url, params).then(res => {
                            this.$message.success(this.viewTitle + '成功！');
                            this.submit_loading = false;
                            this.goBack()
                        }).catch(err => {
                            this.$message.warning(err.msg);
                            this.submit_loading = false;
                        })
                    }
                })
            },
            submit_change() {
                // 更换人员
                const that = this;
                this.submit_loading = true;
                this.$refs.form.validate(valid => {
                    if (valid) {
                        let params = {
                            name: this.form.name,
                            phone: this.form.phone,
                            job_number: this.form.job_number,
                            move_patient: 1, // 是否移交患者 1否2是
                        };
                        let url = `/user/rep_job/change_user?department_id=${this.form.department_id}&job=${this.form.job}`;
                        that.httpPost(url, params).then(res => {
                            if (res.data && res.data.rep_patient_count && res.data.rep_patient_count > 0) {
                                that.$confirm(`确定将该岗位的${res.data.rep_patient_count}位患者移交给该人员么？`).then(() => {
                                    params.move_patient = 2;
                                    that.httpPost(url, params).then(aaa => {
                                        that.$message.success('移交成功！');
                                        that.submit_loading = false;
                                        that.goBack()
                                    })
                                }).catch(() => {
                                    that.$message.warning('已取消');
                                    that.submit_loading = false;
                                })
                            } else {
                                that.$message.success(that.viewTitle + '成功！');
                                that.submit_loading = false;
                                that.goBack()
                            }
                        }).catch(err => {
                            that.$message.warning(err.msg);
                            that.submit_loading = false;
                        })
                    }
                })
            },

            // 搜索医院

            getAllHospital() {
                if (this.hos_search_input || this.hos_search_cascader.length > 0) {
                    let params = {
                        name: this.hos_search_input,
                        province: this.hos_search_cascader[0] ? this.hos_search_cascader[0] : '',
                        city: this.hos_search_cascader[1] ? this.hos_search_cascader[1] : '',
                        page_size: 1000,
                        page: 1
                    };
                    this.httpGet('/hospital', params).then(res => {
                        this.allHos = res.data.data_list;
                        if (res.data.total > 1000) {
                            this.$message.warning('医院数据搜索结果已超过1000条！请精确搜索条件')
                        }
                    })
                } else {
                    this.allHos = []
                }
            },
            select_row(row) {
                let has = false;
                this.selectHos.forEach(v => {
                    if (v.hospital_id == row.hospital_id) {
                        has = true
                    }
                });
                if (has) {
                    this.$message.warning('该医院已选择')
                } else {
                    let item = clone(row);
                    item.drug_code = this.now_select_drug_code;
                    this.selectHos.push(item)
                }
                console.log(this.selectHos, '669');
            },
            delRow(scope) {
                this.selectHos.splice(scope.$index, 1)
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);

    .add_context {
        width: 100%;
        height: 100%;
        background: $view_background;
        display: flex;
        flex-flow: column;

        .header {
            flex: 0 0 50px;
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;

            .title {
            }

            .btn_box {
                padding-right: 20px;

                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }

        .main_box {
            flex: 1;
            padding: 10px;
            display: flex;
            box-sizing: border-box;
            overflow-x: auto;

            .left_box {
                flex: 0 0 440px;
                border-right: 1px solid #fff;
            }

            .right_box {
                flex: 1;
                height: 100%;
                width: 100%;
                min-width: 800px;

                .table_box {
                    height: 100%;
                    display: flex;
                    flex-flow: column;
                    box-sizing: border-box;

                    .table_header {
                        padding: 0 15px;
                        height: 50px;
                        line-height: 50px;
                        background: #fff;
                    }

                    .table_search {
                        padding: 3px 15px;
                        background: #fff;

                        div {
                            padding: 2px 0;
                        }
                        .table_search_title {
                            font-size: 15px;
                        }
                    }

                    .table {
                        flex: 1;
                    }
                }

                .select_table {
                    margin-right: 5px;
                    box-sizing: border-box;
                }

                .all_table {
                }
            }
        }

        .form_item_box {
            position: relative;

            .warning_msg_span {
                position: absolute;
                bottom: -30px;
                left: 10px;
                font-size: 12px;
                color: #E6A23C;
            }
        }
    }
</style>